import React from 'react';
export function ExpertSection() {
  return <section className="w-full bg-bg-dark py-20 px-4 border-t border-border-light/50" data-id="element-76">
      <div className="max-w-3xl mx-auto text-center" data-id="element-77">
        <div className="w-28 h-28 bg-gradient-to-br from-primary to-blue-600 rounded-full mx-auto flex items-center justify-center text-5xl shadow-[0_0_30px_rgba(59,130,246,0.4)] mb-8 border-4 border-bg-dark relative" data-id="element-78">
          <div className="absolute inset-0 rounded-full border-2 border-white/20" data-id="element-79"></div>
          🎨
        </div>

        <h2 className="text-3xl sm:text-4xl font-black text-text-main mb-8 tracking-tight" data-id="element-80">
          A proposito di EDULABS™
        </h2>

        <div className="relative" data-id="element-81">
          <span className="absolute -top-6 -left-4 text-6xl text-primary/20 font-serif" data-id="element-82">
            "
          </span>
          <p className="text-text-main text-xl sm:text-2xl leading-relaxed italic font-medium relative z-10" data-id="element-83">
            Abbiamo creato questo sistema per trasformare l'ora di allenamento
            in un momento di pura eccellenza, togliendo al coach il peso della
            burocrazia e della pianificazione. Meno stress, più vittoria.
          </p>
          <span className="absolute -bottom-10 -right-4 text-6xl text-primary/20 font-serif" data-id="element-84">
            "
          </span>
        </div>
      </div>
    </section>;
}